import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtModule } from "@auth0/angular-jwt";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { NavbarComponent } from "./components/layouts/navbar/navbar.component";
import { HomeFourComponent } from "./components/pages/home/home.component";
import { AboutComponent } from "./components/pages/about-us/about-us.component";
import { TeamComponent } from "./components/pages/team/team.component";
import { FaqComponent } from "./components/pages/faq/faq.component";
import { LogInComponent } from "./components/pages/log-in/log-in.component";
// import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { RecoverPasswordComponent } from "./components/pages/recover-password/recover-password.component";
import { TermsConditionsComponent } from "./components/pages/terms-conditions/terms-conditions.component";
import { PrivacyPolicyComponent } from "./components/pages/privacy-policy/privacy-policy.component";
import { CookiesPolicyComponent } from "./components/pages/cookies-policy/cookies-policy.component";

import { ContactComponent } from "./components/pages/contact/contact.component";
import { NewsRightSidebarComponent } from "./components/pages/news/news-right-sidebar/news-right-sidebar.component";
import { NewsDetailsComponent } from "./components/pages/news/news-details/news-details.component";
import { DedicatedHostingComponent } from "./components/pages/services/dedicated-hosting/dedicated-hosting.component";
import { ComingSoonComponent } from "./components/pages/coming-soon/coming-soon.component";
import { ErrorComponent } from "./components/pages/error/error.component";
import { ClientsComponent } from "./components/pages/general/clients/clients.component";
import { ClientsSaysComponent } from "./components/pages/general/clients-says/clients-says.component";
import { ContactFormComponent } from "./components/pages/general/contact-form/contact-form.component";
import { SitesAreaComponent } from "./components/pages/general/sites-area/sites-area.component";
import { VsOthersComponent } from "./components/pages/general/vs-others/vs-ohters-area.component";
import { HtmlEditorComponent } from "./components/pages/general/html-editor/html-editor.component";

import { LatestNewsComponent } from "./components/pages/general/latest-news/latest-news.component";
import { NoAuthComponent } from "./components/pages/no-auth/no-auth.component";
import { UserPanelComponent } from "./components/pages/user-panel/user-panel.component";

import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";
import { ToastrModule } from "ngx-toastr";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { CommonModule } from "@angular/common";

//Panel
import { PanelLayoutComponent } from "./components/panel/layouts/panel-layout.component";
import { PanelDashboardComponent } from "./components/panel/dashboard/dashboard.component";
import { PanelProfileComponent } from "./components/panel/profile/profile.component";
import { PanelPaymentMethodsComponent } from "./components/panel/payment-methods/payment-methods.component";
import { PanelServicesComponent } from "./components/panel/services/services.component";

import { TimeAgoPipe } from "./utils/pipe/time-ago.pipe";
import { UtcToLocalPipe } from "./utils/pipe/utc-to-local.pipe";
import { TruncatePipe } from "./utils/pipe/truncate.pipe";

import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
//Services

import { ServiceDirectoryComponent } from "./components/pages/services/services-directory/services-directory.component";
import { CloudComputingComponent } from "./components/pages/services/cloud-computing/cloud-computing.component";
import { CloudStorageComponent } from "./components/pages/services/cloud-storage/cloud-storage.component";
import { EquipmentAdministrationComponent } from "./components/pages/services/equipment-administration/equipment-administration.component";
import { GamingServersComponent } from "./components/pages/services/gaming-servers/gaming-servers.component";
import { IntermediateDataProtectionComponent } from "./components/pages/services/intermediate-data-protection/intermediate-data-protection.component";
import { DedicatedDatabaseComponent } from "./components/pages/services/dedicated-database/dedicated-database.component";

import { AgePipe } from "./utils/pipe/age-pipe";
import { ThumbnailPipe } from "./utils/pipe/thumbnail.pipe";

registerLocaleData(localeEs);

export function tokenGetter() {
    return localStorage.getItem("jwtToken");
}

@NgModule({
    declarations: [
        AppComponent,
        PreloaderComponent,
        FooterComponent,
        NavbarComponent,
        HomeFourComponent,
        AboutComponent,
        TeamComponent,
        FaqComponent,
        LogInComponent,
        // SignUpComponent,
        RecoverPasswordComponent,
        TermsConditionsComponent,
        PrivacyPolicyComponent,
        CookiesPolicyComponent,
        ContactComponent,
        NewsRightSidebarComponent,
        NewsDetailsComponent,
        DedicatedHostingComponent,
        ComingSoonComponent,
        ErrorComponent,
        ClientsComponent,
        ClientsSaysComponent,
        ContactFormComponent,
        SitesAreaComponent,
        VsOthersComponent,
        HtmlEditorComponent,
        LatestNewsComponent,
        NoAuthComponent,
        UserPanelComponent,
        PanelLayoutComponent,
        PanelDashboardComponent,
        PanelProfileComponent,
        PanelPaymentMethodsComponent,
        PanelServicesComponent,

        TimeAgoPipe,
        UtcToLocalPipe,
        TruncatePipe,
        ServiceDirectoryComponent,
        CloudComputingComponent,
        CloudStorageComponent,
        EquipmentAdministrationComponent,
        GamingServersComponent,
        IntermediateDataProtectionComponent,
        DedicatedDatabaseComponent,
        AgePipe,
        ThumbnailPipe,
    ],

    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        HttpClientModule,
        BrowserAnimationsModule,
        CKEditorModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: "toast-top-right",
            preventDuplicates: true,
            closeButton: true,
            progressBar: true,
        }),

        JwtModule.forRoot({
            config: {
                tokenGetter,
                allowedDomains: ["localhost:5000"], // Cambia por el dominio
                disallowedRoutes: ["localhost:5000/api/auth/login"],
            },
        }),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: "es-ES" },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
